import HeroSlider from '../components/HeroSlider';
import AboutSection from '../components/AboutSection';
import ScheduleSection from '../components/ScheduleSection';
import TournamentLegacy from '../components/TournamentLegacy';
import SponsorsSection from '../components/SponsorsSection';
import PressSection from '../components/PressSection';
import AppDownloadBanner from '../components/AppDownloadBanner';

function Home() {
  return (
    <main>
      <HeroSlider />
      <AboutSection />
      <ScheduleSection />
      <AppDownloadBanner />
      <TournamentLegacy />
      <PressSection />
      <SponsorsSection />
    </main>
  );
}

export default Home;